import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseActivityEntity } from './activity-history/base-activity.entity';
import { VendorEntity } from './vendor.entity';

/**
 * Per-vendor activity history (DD.11.3) — mirrors ClientActivityEntity
 * exactly so the same UI patterns + base service work for vendors.
 *
 * Powers the vendor detail page's Activity tab (DD.11.5) and is the
 * write target for call-log enrichment (DD.11.4 — when a vendor-
 * matched call completes, append CALL_LOGGED with transcript + AI
 * summary metadata).
 *
 * Indexes match the client variant: (fkVendorId, createdDate) for
 * the activity-feed query, activityType for filtering, fkUserId for
 * "actions by user" reports.
 */
@Index('idx_va_vendor_created', ['fkVendorId', 'createdDate'], {})
@Index('idx_va_type', ['activityType'], {})
@Index('idx_va_user', ['fkUserId'], {})
@Entity('vendor_activity')
export class VendorActivityEntity extends BaseActivityEntity {
	@Column('int', { name: '_fk_vendor__id', unsigned: true })
	public fkVendorId!: number;

	@ManyToOne(() => VendorEntity, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk_vendor__id', referencedColumnName: 'id' }])
	public fkVendor!: VendorEntity;
}
